import { Url } from "./Url.service";
import { HandleResponse, AuthHeader } from "../_helpers";
import { NetworkService } from "./Network.service";

export const VendedorClienteService = {
    obtenerClientesPorVendedor,
    obtenerVendedoresYClientes,
    obtenerVendedores,
    agregarVendedor,
    eliminarVendedor,
    activarVendedor,
    obtenerUsuarioCliente,
    crearVendedorCliente,
    eliminarVendedorCliente,
    ActivarVendedorCliente,
    obtenerRolesVendedor,
    exportarExcel,

};

function obtenerClientesPorVendedor() {
    const requestOptions = { method: "GET", headers: AuthHeader() };
    return fetch(`${Url}Vendedor/obtenerClientesPorVendedor`, requestOptions)
        .then(HandleResponse);
}

function obtenerVendedoresYClientes(buscar_vendedor = "", buscar_cliente = "", id_empresa = null, page = 1, perPage = 20) {
    const requestOptions = { method: "GET", headers: AuthHeader() };

    const params = new URLSearchParams();
    if (buscar_vendedor) params.append("buscar_vendedor", buscar_vendedor);
    if (buscar_cliente) params.append("buscar_cliente", buscar_cliente);
    if (id_empresa) params.append("id_empresa", id_empresa);
    if (page) params.append("page", page);
    if (perPage) params.append("perPage", perPage);

    const query = params.toString();
    const endpoint = `${Url}Vendedor/obtenerVendedoresYClientes${query ? `?${query}` : ""}`;

    return fetch(endpoint, requestOptions).then(HandleResponse);
}

function obtenerVendedores(id_empresa = null, buscar_vendedor = "") {
    const requestOptions = { method: "GET", headers: AuthHeader() };

    const params = new URLSearchParams();
    if (id_empresa) params.append("id_empresa", id_empresa);
    if (buscar_vendedor) params.append("buscar_vendedor", buscar_vendedor);

    const query = params.toString();
    const endpoint = `${Url}Vendedor/obtenerVendedores${query ? `?${query}` : ""}`;

    return fetch(endpoint, requestOptions).then(HandleResponse);
}

function agregarVendedor(datosVendedor) {
    const requestOptions = {
        method: "POST",
        headers: { ...AuthHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(datosVendedor)
    };

    return fetch(`${Url}Vendedor/agregarVendedor`, requestOptions)
        .then(HandleResponse);
}

function eliminarVendedor(id_vendedor) {
    const requestOptions = {
        method: "POST",
        headers: { ...AuthHeader(), "Content-Type": "application/json" },
        body: JSON.stringify({ id_vendedor: id_vendedor })
    };

    return fetch(`${Url}Vendedor/eliminarVendedor`, requestOptions)
        .then(HandleResponse);
}

function activarVendedor(id_vendedor) {
    const requestOptions = {
        method: "POST",
        headers: { ...AuthHeader(), "Content-Type": "application/json" },
        body: JSON.stringify({ id_vendedor: id_vendedor })
    };

    return fetch(`${Url}Vendedor/activarVendedor`, requestOptions)
        .then(HandleResponse);
}

function obtenerUsuarioCliente() {
    const requestOptions = { method: "GET", headers: AuthHeader() };

    return fetch(`${Url}Vendedor/obtenerUsuarioCliente`, requestOptions)
        .then(HandleResponse);
}

function crearVendedorCliente(datosRelacion) {
    const requestOptions = {
        method: "POST",
        headers: { ...AuthHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(datosRelacion)
    };

    return fetch(`${Url}Vendedor/crearVendedorCliente`, requestOptions)
        .then(HandleResponse);
}

function eliminarVendedorCliente(id_vendedor_cliente) {
    const requestOptions = {
        method: "POST",
        headers: { ...AuthHeader(), "Content-Type": "application/json" },
        body: JSON.stringify({ id_vendedor_cliente: id_vendedor_cliente })
    };

    return fetch(`${Url}Vendedor/eliminarVendedorCliente`, requestOptions)
        .then(HandleResponse);
}

function ActivarVendedorCliente(id_vendedor_cliente) {
    const requestOptions = {
        method: "POST",
        headers: { ...AuthHeader(), "Content-Type": "application/json" },
        body: JSON.stringify({ id_vendedor_cliente: id_vendedor_cliente })
    };

    return fetch(`${Url}Vendedor/ActivarVendedorCliente`, requestOptions)
        .then(HandleResponse);
}

function obtenerRolesVendedor() {
    const requestOptions = { method: "GET", headers: AuthHeader() };

    return fetch(`${Url}Vendedor/obtenerRolesVendedor`, requestOptions)
        .then(HandleResponse);
}

function exportarExcel(buscar_vendedor = "", buscar_cliente = "", id_empresa = null) {
    const requestOptions = { method: "GET", headers: AuthHeader() };

    const params = new URLSearchParams();
    if (buscar_vendedor) params.append("buscar_vendedor", buscar_vendedor);
    if (buscar_cliente) params.append("buscar_cliente", buscar_cliente);
    if (id_empresa) params.append("id_empresa", id_empresa);

    const query = params.toString();
    const endpoint = `${Url}Vendedor/exportarVendedoresClientes${query ? `?${query}` : ""}`;

    return fetch(endpoint, requestOptions)
        .then(async (response) => {
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || "Error en el servidor al generar Excel");
            }
            return response.blob();
        })
        .then((blob) => {
            // Magia para descargar el archivo en el navegador
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "vendedores_y_clientes.xlsx"; 
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        });
}